<template>
  <div>
    <bp-alert
      v-if="notification.message"
      v-test:alert="'edit success client'"
      v-bind="{ type: notification.type }"
      show-icon
      closable
      @close="setEmployerNotification"
    >
      <!-- eslint-disable-next-line -->
      <div v-html="notification.message" />
    </bp-alert>

    <section id="container-client-overview">
      <div>
        <table-active-events
          v-bind="{
            clientId,
            sortDirection: $route.query.activeEventsSortDirection,
            sortProp: $route.query.activeEventsSortProp,
          }"
          @changeSortCriteria="$router.push({
            query: {
              ...$route.query,
              activeEventsSortProp: $event.sortProp,
              activeEventsSortDirection: $event.sortDirection,
            }
          })"
        />
      </div>
      <div>
        <table-coverage
          v-bind="{
            clientId,
            clientName,
            sortDirection: $route.query.currentCoveragesSortDirection,
            sortProp: $route.query.currentCoveragesSortProp,
          }"
          @changeSortCriteria="$router.push({
            query: {
              ...$route.query,
              currentCoveragesSortProp: $event.sortProp,
              currentCoveragesSortDirection: $event.sortDirection,
            }
          })"
          @clickAddCurrentCoverage="$router.push({ name: 'NewCurrentCoverage' })"
        />
      </div>
      <div class="column">
        <table-broker-team
          id="container-broker-team"
          v-bind="{
            clientId,
            sortDirection: $route.query.brokerTeamSortDirection,
            sortProp: $route.query.brokerTeamSortProp,
          }"
          @changeSortCriteria="$router.push({
            query: {
              ...$route.query,
              brokerTeamSortProp: $event.sortProp,
              brokerTeamSortDirection: $event.sortDirection,
            }
          })"
          @clickAddTeamMember="$router.push({ name: 'AddBrokerTeamContact' })"
        />
      </div>
      <div class="column">
        <table-census-sources
          id="container-census-sources"
          v-bind="{
            clientId,
            sortDirection: $route.query.censusSortDirection,
            sortProp: $route.query.censusSortProp,
          }"
          @changeSortCriteria="$router.push({
            query: {
              ...$route.query,
              censusSortProp: $event.sortProp,
              censusSortDirection: $event.sortDirection,
            }
          })"
          @clickAddCensus="$router.push({ name: 'AddCensusSources' })"
        />
      </div>
    </section>
    <router-view />
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';

  /**
   * The "ClientOverview" view is a collection of tables a broker can review to get a general overview of a particular client.
   *
   * @vuedoc
   * @exports ClientRecord/ClientOverview
   * @category Views
   */
  export default {
    name: 'ClientOverview',
    components: {
      TableActiveEvents: () => import('@/components/Employer/Tables/ActiveEvents'),
      TableCensusSources: () => import('@/components/Employer/Tables/CensusSources'),
      TableCoverage: () => import('@/components/Employer/Tables/Coverage'),
      TableBrokerTeam: () => import('@/components/Employer/Tables/BrokerTeam'),
    },
    props: {
      clientId: {
        type: [String, Number],
        required: true,
      },
      showModal: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        clientName: (state) => state.employer.employerInfo.name,
        isNew: (state) => state.employer.isNew,
        notification: (state) => state.employer.notification,
      }),
    },
    methods: {
      ...mapMutations({
        setEmployerNotification: 'SET_EMPLOYER_NOTIFICATION',
      }),
    },
  };
</script>

<style scoped lang="scss">
  .bp-alert {
    margin: 30px auto 10px;
    max-width: 697px;

    &::v-deep p + p {
      margin-top: 18px;
    }
  }

  #container-client-overview {
    display: flex;
    flex-wrap: wrap;
    margin: -15px -15px 15px;

    > div {
      box-sizing: border-box;
      margin: 15px;

      &.column {
        flex: 6;
      }
    }
  }
</style>
